module.exports = __webpack_public_path__ + "img/panda_express.ca2a6daf.svg";